export default __webpack_public_path__ + "static/low-rate-card-882f0ba42cf75709f428c583cff1cd44.png";